import { useEffect } from "react";
import { ArrowUpRight } from "lucide-react";
import { images, site, reviews, reviewHighlights } from "../data/siteData";
import { PageHero } from "../components/PageHero";
import { SectionHeading } from "../components/SectionHeading";
import { ReviewCard, Stars } from "../components/ReviewCard";
import { Reveal } from "../components/Reveal";

export default function Reviews() {
  useEffect(() => {
    document.title = "Reviews | Mango – World Cuisine Restaurant, Bhavnagar";
  }, []);

  return (
    <>
      <PageHero
        overline="Guest Reviews"
        lines={["Loved by", "Bhavnagar."]}
        image={images.heroReviews}
      />

      <section data-testid="reviews-summary" className="py-20 md:py-28 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal>
            <p data-testid="reviews-rating-value" className="font-display text-7xl md:text-8xl text-forest">
              {site.rating}
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-4 flex justify-center">
              <Stars size={24} />
            </div>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-4 text-charcoal/60">{site.reviewCount} Google Reviews</p>
          </Reveal>
          <Reveal delay={0.26}>
            <div className="mt-8 flex flex-wrap justify-center gap-2">
              {reviewHighlights.map((h) => (
                <span
                  key={h}
                  data-testid={`review-highlight-${h.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="rounded-full border border-forest/15 bg-sand px-4 py-2 text-xs font-semibold text-forest"
                >
                  {h}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <SectionHeading overline="In Their Words" title="What guests are saying" />
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((r, i) => (
              <Reveal key={r.name} delay={(i % 3) * 0.08}>
                <ReviewCard review={r} />
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-16 text-center">
            <p className="font-display text-2xl md:text-3xl text-charcoal">
              Visited Mango? Share your experience on Google.
            </p>
            <a
              href={site.googleReviewUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-google-cta-button"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-forest px-8 py-4 text-sm font-semibold text-ivory transition-all duration-300 hover:bg-forest-deep hover:-translate-y-0.5"
            >
              Write a Review
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>
        </div>
      </section>
    </>
  );
}
